import types from "./types";

const initialState = {
    list: [],
    costpackage: null,
    filters: {},
    pagination: {
        actualPage: 1,
        previous: null,
        next: null,
        pages: 0,
        count: 0
    },
    error: null,
    loading: false,
    loaded: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.GET_COSTPACKAGE_DETAIL:
        case types.GET_COSTPACKAGE: {
            return {
                ...state,
                loading: true,
                loaded: false
            };
        }
        case types.GET_COSTPACKAGE_SUCCESS: {
            const list = action.payload.reduce((entities, costpackage) => {
                return {
                    ...entities,
                    [costpackage.id]: {
                        ...costpackage
                    }
                };
            }, {});
            return {
                ...state,
                list,
                loading: false,
                loaded: true
            };
        }

        case types.GET_COSTPACKAGE_DETAIL_SUCCESS: {
            return {
                ...state,
                costpackage: action.payload,
                loading: false,
                loaded: true
            };
        }

        case types.GET_COSTPACKAGE_DETAIL_FAIL:
        case types.GET_COSTPACKAGE_FAIL: {
            return {
                ...state,
                loading: false,
                loaded: false,
                error: action.payload
            };
        }

        case types.CHANGE_PAGE: {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    actualPage: action.payload.page
                }
            };
        }

        case types.UPDATE_PAGINATION: {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    actualPage: action.payload.actual,
                    pages: action.payload.pages,
                    next: action.payload.next,
                    previous: action.payload.previous,
                    count: action.payload.count
                }
            };
        }

        case types.FILTER_LIST: {
            return {
                ...state,
                filters: action.payload
            };
        }

        default: {
            return state;
        }
    }
};
